const filterListModalFilterExpiredServices = {
  filter: 'FILTROS',
  clear: 'limpar filtros'
};

export default filterListModalFilterExpiredServices;
